import React from "react";
import { Marker, Pane } from "react-leaflet";
import { treeDrawnMarker } from "./TreeDrawing";
import { connect } from "react-redux";

class TreeDuringMovement extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <Pane className="tree-area">
        {this.props.inTreeDrawingMode &&
          this.props.currentCursorCoords &&
          this.props.displayTreeCursor && (
            <Marker
              icon={treeDrawnMarker}
              position={this.props.currentCursorCoords}
              zIndex={1}
              zIndexOffset={1}
            />
          )}
      </Pane>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    currentCursorCoords: state.map.currentCursorCoords,
    inTreeDrawingMode: state.map.inTreeDrawingMode,
    displayTreeCursor: state.map.displayTreeCursor,
  };
};

export default connect(mapStateToProps, null)(TreeDuringMovement);
